
const FETCH_JWEXPERTTEAN="FETCH_JWEXPERTTEAN"; //经纬专家团队
const FETCH_WORK_ENVIORONMENT="FETCH_WORK_ENVIORONMENT"; //工作环境
const FETCH_WORK_REQUIRMENT="FETCH_WORK_REQUIRMENT"; //岗位要求
const FETCH_APPLY_WAY="FETCH_APPLY_WAY";  // 应聘方式
const FETCH_NEW_EMPLOYEE_NOTE="FETCH_NEW_EMPLOYEE_NOTE";
const FETCH_CONTACT_US="FETCH_CONTACT_US";

const ActionType={
    FETCH_JWEXPERTTEAN,
    FETCH_WORK_ENVIORONMENT,
    FETCH_WORK_REQUIRMENT,
    FETCH_APPLY_WAY,
    FETCH_NEW_EMPLOYEE_NOTE,
    FETCH_CONTACT_US,
}


export default ActionType;